import React, { useCallback } from 'react';
import { useActions } from 'hooks';
import { Logo, Icon, styled } from 'hyarchis-global';
import { ASSETS } from 'app-constants';
import { openDrawer as openDrawerAction } from 'store/drawers/actions';
import { DrawerType } from 'types/drawers';
import { useNavigate } from 'react-router-dom';
import Styled from '../root/drawers/drawers.styled';

const { StyledButton } = Styled;

interface OwnProps {
  style?: React.CSSProperties;
}

const StyledWrapper = styled.div`
  display: flex;
  background: ${(props) =>
    `linear-gradient(90deg, ${props.theme.colors.gradientStart} 0%, ${props.theme.colors.gradientEnd} 250%);`}
  width: 100%;
  height: ${(props) => props.theme.sizes.topBarHeight}px;
  padding: 0 20px;
  box-shadow: 0px -10px 6px 12px rgba(0, 0, 0, 0.15);
`;

const StyledIcon = styled(Icon)`
  color: ${(props) => props.theme.colors.topBarText};
  margin: calc((${(props) => props.theme.sizes.topBarHeight}px - 21px) * 0.5) 0;
  margin-left: auto;
`;

const StyledCenteredButton = styled(StyledButton)`
  align-self: center;
`;

const TopBarContainer = ({ style }: OwnProps) => {
  const { openDrawer } = useActions({ openDrawer: openDrawerAction });
  const navigate = useNavigate();

  const navigateTo = (link: string) => {
    navigate(link);
  };

  const handleOpenSettings = useCallback(() => {
    openDrawer({
      drawerType: DrawerType.settingsOpen,
    });
  }, [openDrawer]);

  return (
    <StyledWrapper style={style} data-test-id='top-bar'>
      <Logo logoSrc={ASSETS.LOGO_TOP_BAR} href='' data-test-id='top-bar-logo' />
      <StyledCenteredButton onClick={() => navigateTo('/')}>Processing jobs</StyledCenteredButton>
      <StyledCenteredButton onClick={() => navigateTo('/documentsGroups')}>
        Documents groups
      </StyledCenteredButton>
      <StyledIcon icon='cog' type='regular' size={20} clickable onClick={handleOpenSettings} />
    </StyledWrapper>
  );
};

export default React.memo(TopBarContainer);
